import { resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.block)
    ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.resolvedBlock), _mergeProps({
        key: 0,
        content: _ctx.block.model,
        alias: _ctx.block.contentType,
        "is-first-block": _ctx.isFirstBlock,
        parent: _ctx.parent
      }, _ctx.$attrs), null, 16, ["content", "alias", "is-first-block", "parent"]))
    : _createCommentVNode("", true)
}